import z from "zod";

export const loginFormSchema = z.object({
  email: z.email("Format email tidak tepat").min(1, "Email harus diisi"),
  password: z.string("Password harus diisi").min(1, "Password harus diisi"),
});
export type LoginFormDto = z.infer<typeof loginFormSchema>;

export const forgotPasswordFormSchema = z.object({
  email: z.email("Format email tidak tepat").min(1, "Email harus diisi"),
});
export type ForgotPasswordFormDto = z.infer<typeof forgotPasswordFormSchema>;

export const resetPasswordSchema = z.object({
  token: z.string().min(1, "Token reset password tidak valid"),
  password: z
    .string()
    .min(8, "Password minimal 8 karakter")
    .regex(/[A-Z]/, "Password harus mengandung huruf besar")
    .regex(/[a-z]/, "Password harus mengandung huruf kecil")
    .regex(/[0-9]/, "Password harus mengandung angka"),
  password_confirmation: z.string().min(1, "Konfirmasi password wajib diisi"),
}).refine(
  (data) => data.password === data.password_confirmation,
  {
    path: [
      "password_confirmation",
    ],
    message: "Konfirmasi password tidak cocok",
  }
);
export type ResetPasswordFormDto = z.infer<typeof resetPasswordSchema>;